<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1">{{ data1['druidParamName'] }}<em v-if="data1['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data1['price'] }}</span></div>
        <div class="data2">{{ `${data2['druidParamName']}` }}<em v-if="data2['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data2['price'] }}</span>
        </div>
        <div class="data3">{{ `${data3['druidParamName']}` }}<em v-if="data3['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data3['price'] }}</span>
        </div>
        <div class="data4">{{ `${data4['druidParamName']}` }}<em v-if="data4['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data4['price'] }}</span>
        </div>
        <div class="data5">{{ `${data5['druidParamName']}` }}<em v-if="data5['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data5['price'] }}</span>
        </div>
        <div class="data6">{{ `${data6['druidParamName']}` }}<em v-if="data6['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data6['price'] }}</span>
        </div>
        <div class="data7">{{ `${data7['druidParamName']}` }}<em v-if="data7['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data7['price'] }}</span>
        </div>
        <div class="data8">{{ `${data8['druidParamName']}` }}<em v-if="data8['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data8['price'] }}</span>
        </div>
        <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
          {{ '+' + chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
        <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
          {{ '+' + chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
        <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
          {{ '+' + chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
        <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
          {{ '+' + chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
        <div class="differPrice5 redColor" v-if="chainPrice['differPrice5'] > 0">
          {{ '+' + chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5 greenColor" v-if="chainPrice['differPrice5'] < 0">{{ chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">—</div>
        <div class="differPrice6 redColor" v-if="chainPrice['differPrice6'] > 0">
          {{ '+' + chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6 greenColor" v-if="chainPrice['differPrice6'] < 0">{{ chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">—</div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write" @mouseover="changeFlag(2)" @click="toTwoPage('/steel/twoPage/industry', '2')"
               :class="{'title-write-red' : industryFlag===2}">行业动态
          </div>
          <div class="title-write" @mouseover="changeFlag(3)" @click="toTwoPage('/steel/twoPage/industry', '3')"
               :class="{'title-write-red' : industryFlag===3}">钢厂动态
          </div>
          <span class="title-more fr" @click="toTwoPage('/steel/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content" v-if="industryFlag === 2">
          <ul>
            <li v-for="(item, index) in industryList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/steel/industry', item.id, 2)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
        <div class="banner-right-content" v-else>
          <ul>
            <li v-for="(item, index) in industryListTabs" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/steel/industry', item.id, 3)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li style="position: relative">
          <img src="../../assets/steel/zixun.png" alt="">
          <span @click="toTwoPage('/steel/twoPage/enterprise')"
                style="right: 10px;position: absolute;top: 24px;color: #fff;cursor: pointer;"> >></span>
          <img src="../../assets/home/neibu.png" style="position: absolute;left: 183px;width: 70px;top: 24px;" alt="">
          <div class="classification-content">
            <!--            <Expect></Expect>-->
            <div class="classification-content-div" v-for="(item, index) in enterpriseList" :key="index">
              <i></i>
              <p @click="goDetail('/steel/enterprise', item.collection_time)">
                {{ item.showTimeword + '钢铁重点企业资讯' }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'价格'" :flag="false" :unit="false" :url="'/steel/twoPage/price'"
                                :params="{title:'价格指数',typeList:['螺纹价格', '热卷价格', '钢坯价格']}"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="priceFlag = 1"
                @click="toTwoPage('/steel/twoPage/price', 'issue_steel_thread_price')"
                :class="{'priceFlag':priceFlag === 1}">螺纹价格</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 2"
                @click="toTwoPage('/steel/twoPage/price', 'issue_steel_hot_price')"
                :class="{'priceFlag':priceFlag === 2}">热卷价格</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 3"
                @click="toTwoPage('/steel/twoPage/price', 'issue_steel_billet_price')"
                :class="{'priceFlag':priceFlag === 3}">钢坯价格</span>
          <div class="classification-content" v-if="priceFlag === 1">
            <div class="classification-content-div price" v-for="(item, index) in priceOneList" :key="index"
                 @click="goDetail('/steel/price', item.completeOriginalDate, 'issue_steel_thread_price')">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.date + '螺纹价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="priceFlag === 2">
            <div class="classification-content-div price" v-for="(item, index) in priceTwoList" :key="index"
                 @click="goDetail('/steel/price', item.completeOriginalDate, 'issue_steel_hot_price')">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.date + '热卷价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="priceFlag === 3">
            <div class="classification-content-div price" v-for="(item, index) in priceThreeList" :key="index"
                 @click="goDetail('/steel/price', item.completeOriginalDate, 'issue_steel_billet_price')">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.date + '钢坯价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <span class="fr" @click="toTwoPage('/steel/twoPage/report')"> >></span>
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/steel/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/steel/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/steel/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'产量'" :flag="false" :unit="false" :url="'/steel/twoPage/yield'"
                                :params="{title:'产量',typeList:['五大品种合计产量', '粗钢/生铁/钢材产量', '中钢协产量', '国际产量']}"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="yieldFlag = 1"
                @click="toTwoPage('/steel/twoPage/yield', 'issue_steel_varieties_yield', 2)"
                :class="{'stockFlag':yieldFlag === 1}"
                style="font-size: 12px;height: 36px; padding: 0 20px; width: 53px; line-height: revert;">五大品种合计产量</span>
          <span class="classification-tabs-three" @mouseover="yieldFlag = 2"
                @click="toTwoPage('/steel/twoPage/yield', 'issue_steel_group_province', 5)"
                :class="{'stockFlag':yieldFlag === 2}"
                style="vertical-align: bottom;font-size: 12px;height: 36px; padding: 0 12px; width: 69px; line-height: revert;">粗钢/生铁/钢材产量</span>
          <span class="classification-tabs-three" @mouseover="yieldFlag = 3"
                @click="toTwoPage('/steel/twoPage/yield', '7')"
                :class="{'stockFlag':yieldFlag === 3}" style="vertical-align: top;">中钢协产量</span>
          <span class="classification-tabs-three" @mouseover="yieldFlag = 4"
                @click="toTwoPage('/steel/twoPage/yield', '6')"
                :class="{'stockFlag':yieldFlag === 4}" style="vertical-align: top;">国际产量</span>
          <div class="classification-content" v-if="yieldFlag === 1">
            <div class="classification-content-div" v-for="(item, index) in yieldList" :key="index"
                 @click="goDetail('/steel/yield', item.completeOriginalDate, 'issue_steel_varieties_yield')">
              <i></i>
              <p>{{ item.date + '五大品种合计产量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="yieldFlag === 2">
            <div class="classification-content-div" v-for="(item, index) in yieldListTwo" :key="index"
                 @click="goDetail('/steel/yield', item.completeOriginalDate, 'issue_steel_group_province')">
              <i></i>
              <p>{{ item.date + '粗钢/生铁/钢材产量分省' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="yieldFlag === 3">
            <div class="classification-content-div" v-for="(item, index) in yieldListThree" :key="index"
                 @click="goDetail('/steel/industry', item.id, '7')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="yieldFlag === 4">
            <div class="classification-content-div" v-for="(item, index) in yieldListFour" :key="index"
                 @click="goDetail('/steel/industry', item.id, '6')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'库存'" :flag="false" :unit="false" :url="'/steel/twoPage/stock'"
                                :params="{title:'库存',typeList:['螺纹合计', '热卷合计', '五大品种合计']}"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="stockFlag = 1"
                @click="toTwoPage('/steel/twoPage/stock', 'issue_steel_thread_stock')"
                :class="{'stockFlag':stockFlag === 1}">螺纹合计</span>
          <span class="classification-tabs-three" @mouseover="stockFlag = 2"
                @click="toTwoPage('/steel/twoPage/stock', 'issue_steel_hot_stock')"
                :class="{'stockFlag':stockFlag === 2}">热卷合计</span>
          <span class="classification-tabs-three" @mouseover="stockFlag = 3"
                @click="toTwoPage('/steel/twoPage/stock', 'issue_steel_varieties_stock')"
                :class="{'stockFlag':stockFlag === 3}">五大品种合计</span>
          <div class="classification-content" v-if="stockFlag === 1">
            <div class="classification-content-div" v-for="(item, index) in stockOneList" :key="index"
                 @click="goDetail('/steel/stock', item.completeOriginalDate, 'issue_steel_thread_stock')">
              <i></i>
              <p>{{ item.date + '螺纹合计库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="stockFlag === 2">
            <div class="classification-content-div" v-for="(item, index) in stockTwoList" :key="index"
                 @click="goDetail('/steel/stock', item.completeOriginalDate, 'issue_steel_hot_stock')">
              <i></i>
              <p>{{ item.date + '热卷合计库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="stockFlag === 3">
            <div class="classification-content-div" v-for="(item, index) in stockThreeList" :key="index"
                 @click="goDetail('/steel/stock', item.completeOriginalDate, 'issue_steel_varieties_stock')">
              <i></i>
              <p>{{ item.date + '五大品种合计库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none;">
            <em></em>
            <p>企业分布 <b style="color: #D3131A;font-size: 18px;margin-left: -5px;font-weight: normal">地图</b></p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
          </div>
          <div class="classification-content">
            <img style="cursor: pointer" src="../../assets/home/map.png" @click="goDetail('/steel/map')" alt="">
<!--            <Expect :marginTop="'40px'"></Expect>-->
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'进出口量'" :flag="false" :unit="true"
                                :url="'/steel/twoPage/exit'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in exitOneList" :key="index"
                 @click="goDetail('/steel/exit', item.completeOriginalDate)">
              <i></i>
              <p>{{ item.date + '钢铁进出口量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li style="position:relative;">
          <ClassificationHeader :name="'技术及标准'" :flag="true" :unit="false" :url="'/steel/twoPage/standard'" :neibu="true"
                                :params="{title:'技术及标准'}"></ClassificationHeader>
          <div class="exitClass">
            <div class="classification-content-div" v-for="(item, index) in standardList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadStandard(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li style="position: relative">
          <img src="../../assets/steel/dashuju.png" alt="">
          <img src="../../assets/home/neibu.png" style="width: 70px;position: absolute;left: 200px;top: 25px;" alt="">
          <span style="position: absolute;right: 10px;top: 27px;cursor: pointer;color:#fff"
                @click="toTwoPage('/steel/twoPage/forecast', JSON.stringify({url:'/steel', varieties: '钢铁'}))"> >></span>
          <div class="classification-content">
            <div class="classification-content-div map" v-for="(item, index) in forecastList"
                 @click="goDetail('/steel/forecast', item.id, '/steel', item.predictType )" :key="index">
              <i></i>
              <p>{{ item.showYearTime + item.predictType + '价格预测' }}</p>
              <span class="fr">{{ item.showEndTime }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="980px"
               :visible.sync="industrialFlag">
      <CokeIndustrial :chainPrice="chainPrice" :chainTitle="chainTitle" :data1="data1" :data2="data2" :data3="data3"
                      :data4="data4" :data5="data5" :data6="data6" :data7="data7" :data8="data8"
                      @closeIndustrialCh="closeIndustrial"></CokeIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import ClassificationHeader from '@/components/common/ClassificationHeader'
import Expect from '@/components/common/expect'
import CokeIndustrial from '@/components/bigChart/cokeIndustrial'
import {
  steelPriceNoAuthList,
  stockNoAuthList,
  steelYieldNoAuthList,
  industryNoAuthList,
  exitNoAuthList,
  industryDetail,
  steelReportDetail,
  standardDetail,
  steelExamineNoAuthList
} from '@/api/steel'
import {reportNoAuthList} from "@/api/coke";
import {chainList, forecastNoAuthList} from '@/api'

export default {
  name: "index",
  components: {
    ClassificationHeader,
    Expect,
    CokeIndustrial
  },
  data() {
    return {
      // 价格预测
      forecastList: [],
      industryFlag: 2,
      jiaotan: [],
      jiage: [],
      yanjiu: [],
      // 行业动态
      industryList: [],
      industryListTabs: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 1,
      priceOneList: [],
      priceTwoList: [],
      priceThreeList: [],
      // 库存
      stockFlag: 1,
      stockOneList: [],
      stockTwoList: [],
      stockThreeList: [],
      // 开工率
      rateList: [],
      // 进出口量
      exitOneList: [],
      exitTwoList: [],
      // 新增淘汰产能
      boardList: [],
      // 产量
      yieldFlag: 1,
      yieldList: [],
      yieldListTwo: [],
      yieldListThree: [],
      yieldListFour: [],
      // 行业标准
      standardList: [],
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      chainPrice: {},
      // 重点企业资讯
      enterpriseList: [],
      industrialFlag: false,
    }
  },
  created() {
    this.getHomeList()
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // 价格预测
      forecastNoAuthList({pageNum: 1, pageSize: 7, varieties: '螺纹钢,热卷,方坯'}).then(res => {
        this.forecastList = res.rows;
      })
      steelExamineNoAuthList({pageNum: 1, pageSize: 7}).then(res => {
        this.enterpriseList = res.rows
      })
      // 产业链
      chainList({dictDataType: 'issue_coal_stell_chain_price'}).then(res => {
        this.chainTitle = res.data['data1']['date'];
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
        this.data4 = res.data['data4'];
        this.data5 = res.data['data5'];
        this.data6 = res.data['data6'];
        this.data7 = res.data['data7'];
        this.data8 = res.data['data8'];
        this.chainPrice = res.data['price'];
      })
      // 行业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 2}).then(res => {
        this.industryList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 3}).then(res => {
        this.industryListTabs = res.rows;
      })
      // 研究报告
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 2, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 2, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 2, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 行业标准
      reportNoAuthList({pageNum: 1, pageSize: 7, sourceType: 2, fileType: 4}).then(res => {
        this.standardList = res.rows;
      })
      // 价格指数
      steelPriceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_steel_thread_price',
        dataType: 1
      }).then(res => {
        this.priceOneList = res.rows;
      })
      steelPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_steel_hot_price', dataType: 1}).then(res => {
        this.priceTwoList = res.rows;
      })
      steelPriceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_steel_billet_price',
        dataType: 1
      }).then(res => {
        this.priceThreeList = res.rows;
      })
      // 库存
      stockNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_steel_thread_stock', dataType: 2}).then(res => {
        this.stockOneList = res.rows
      })
      stockNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_steel_hot_stock', dataType: 2}).then(res => {
        this.stockTwoList = res.rows
      })
      stockNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_steel_varieties_stock', dataType: 2}).then(res => {
        this.stockThreeList = res.rows
      })
      // 产量
      steelYieldNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_steel_varieties_yield',
        dataType: 2
      }).then(res => {
        this.yieldList = res.rows;
      })
      steelYieldNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_steel_group_province',
        dataType: 3
      }).then(res => {
        this.yieldListTwo = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 7}).then(res => {
        this.yieldListThree = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 6}).then(res => {
        this.yieldListFour = res.rows;
      })
      // 进出口量
      exitNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_steel_exit', dataType: 3}).then(res => {
        this.exitOneList = res.rows;
      })
    },
    /**
     * 前往行业报告二级
     */
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 预览文件
     */
    downloadReport(row) {
      steelReportDetail(row['id'] + "/1").then((res) => {
        this.$setMenuInfoPath(['钢铁', '研究报告', '正文'], row['id']);
      })
    },
    downloadStandard(row) {
      standardDetail(row['id'] + "/1").then((res) => {
        this.$setMenuInfoPath(['钢铁', '技术及标准', '正文'], row['id']);
      })
    },
    /**
     * 切换tabs
     */
    changeFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag, other) {
      this.$router.push({path: `${url}`, query: {id: id, flag: flag, other:other}})
    },
  },
}
</script>

<style scoped lang="less">

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/steel/banner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      top: 30px;
      left: 272px;
    }

    .data1 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 29px;
      width: 106px;
      height: 50px;
    }

    .data2 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 179px;
      width: 106px;
      height: 50px;
    }


    .data3 {
      font-size: 4px;
      position: absolute;
      top: 251px;
      left: 176px;
      width: 115px;
      height: 50px;
    }

    .data4 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 345px;
      width: 106px;
      height: 50px;
    }

    .data5 {
      font-size: 10px;
      position: absolute;
      top: 39px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 128px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data7 {
      font-size: 10px;
      position: absolute;
      top: 215px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data8 {
      font-size: 10px;
      position: absolute;
      top: 305px;
      right: 18px;
      width: 119px;
      height: 50px;
    }

    .differPrice1 {
      position: absolute;
      top: 131px;
      left: 297px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice2 {
      position: absolute;
      top: 248px;
      left: 303px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice3 {
      position: absolute;
      top: 38px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice4 {
      position: absolute;
      top: 130px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice5 {
      position: absolute;
      top: 210px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice6 {
      position: absolute;
      top: 295px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
        cursor: pointer;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          vertical-align: middle;
          margin-right: 9px;

        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 124px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        border-top: 2px solid #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-three {
        width: 93px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            text-decoration: underline;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;
          padding: 0 10px;

          img {
            margin-right: 5px;
            width: 8px;
          }
        }

        .price:nth-child(2n+0) {
          background: #F2F2F2;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.bulletinWai {
  overflow: auto;
  height: 211px;
  border-bottom: 1px solid #ccc;
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}
</style>
